import { Navigate, Outlet, Route } from "react-location";

import {
  CogIcon,
  DocumentTextIcon,
  FolderIcon,
  HomeIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";
import PusherConnectionTest from "components/test/PusherConnectionTest";
import AllBusinesses from "pages/AllBusiness";
import {
  AllTreatiesPage,
  ClaimsPage,
  ClosedOffersPage,
  DashboardPage,
  ForgotPasswordPage,
  HoldOffersPage,
  LoginPage,
  ReportsPage,
  ResetPasswordPage,
  SettingsPage,
} from "../pages";

export type RouteProps = Omit<Route, "children"> & {
  // withPermissions?: UserPermission[];
  navigation?: boolean;
  sidebar?: { label: string; icon: any };
  children?: RouteProps[];
};

const routes: RouteProps[] = [
  {
    path: "/app/dashboard",
    element: <Outlet />,
    sidebar: {
      label: "Dashboard",
      icon: HomeIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Dashboard",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <DashboardPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/businesses",
    element: <Outlet />,
    sidebar: {
      label: "Published Offers",
      icon: FolderIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Published Offers",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <AllBusinesses />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: "/test",
        element: <PusherConnectionTest />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/offers",
    element: <Outlet />,
    sidebar: {
      label: "Closed Offers",
      icon: FolderIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Closed Offers",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <ClosedOffersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/hold-cover",
    element: <Outlet />,
    sidebar: {
      label: "Hold Cover",
      icon: ShieldCheckIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "hold-cover",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <HoldOffersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/claims",
    element: <Outlet />,
    sidebar: {
      label: "Claims",
      icon: DocumentTextIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Claims",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <ClaimsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/treaties",
    element: <Outlet />,
    sidebar: {
      label: "All Treaties",
      icon: FolderIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "All Treaties",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <AllTreatiesPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/reports",
    element: <Outlet />,
    sidebar: {
      label: "Reports",
      icon: FolderIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Reports",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <ReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "app/settings",
    element: <Outlet />,
    sidebar: {
      label: "Settings",
      icon: CogIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Settings",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <SettingsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "/",
    element: <Navigate to="/cpanel-login" />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Auth",
    },
  },
  {
    path: "cpanel-login",
    element: <LoginPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Auth",
    },
  },
  {
    path: "forgot-password",
    element: <ForgotPasswordPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Forgot Password",
    },
  },
  {
    path: "reset-password",
    element: <ResetPasswordPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Reset Password",
    },
  },
];

export default routes;
